<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "UsersPage",
};
</script>

<style scoped lang="scss"></style>
